import React from "react";
import { Grid, Typography } from "@mui/material";

function CardTitle({ title, children }) {
	return (
		<Grid
			item
			xs={12}
			lg={12}
			xl={12}
			sm={12}
			sx={{ m: 1 }}
			style={{ justifyContent: "flex-start" }}
		>
			<Typography variant="h5" component="h5" sx={{ display: "flex" }}>
				{title}
			</Typography>
			{children}
		</Grid>
	);
}

export default CardTitle;
